<template>
    <div v-if="hasAuth('Rem')">
        <template v-if="hasModule('REMManagement')">
            <list-container :header="translate('remInboxList.kepOutgoingBox')" v-show="!$route.params.id">
                <template v-slot:commands>
                    <!-- <excel-exporter table-id="categoryExport" :columns="columns" url="/category/get" modelName="Category" orderBy="Name"></excel-exporter>
                    <button class="btn btn-primary" @click="$router.push({ name:'CategoryDetail', params: { id: '000000000000000000000000' } })">
                        Yeni Kategori
                    </button> -->
                    
                </template>
                <list :columns="columns" url="/rembox/get/" :filter="{ Type: 'Outgoing', ProviderId: $route.params.provider }" :hideDeleteCommand="true" modelName="RemOutbox" orderBy="SentDate desc">
                </list>
            </list-container>
            <router-view v-if="$route.params.id" />
        </template>
        <div v-else>
            <div class="alert alert-warning">
                <h4>{{translate('warnings.kepManagementNotActive')}}</h4>
                <p>
                  {{translate('kepManagementText')}}&nbsp;<a class="alert-link" :href="'mailto:bilgi@izometri.com.tr?subject=' + translate('kepManagementActivation:' + currentAccount.Code)" target="_blank">bilgi@izometri.com.tr</a>&nbsp;{{translate('licenceExpiredText2')}} <a class="alert-link" href="tel:+902127061736">+90(212) 706 1736</a> {{translate('licenceExpiredText3')}}
                </p>
            </div>
        </div>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'
import Vue from 'vue'
//import ExcelExporter from '../components/ExcelExporter.vue';

export default {
    computed: {
        currentAccount(){
            return this.$root.$data.login.Account;
        }
    },
    data(){
        return {
            columns : [
                {
                    Key: "To.Address",
                    Title: this.translate('remPreview.receiver'),
                    SortField: "To.Address",
                    Content(i) {
                        if(!i || !i.To)
                            return '';
                        return `<span title="${i.To[0]?.Name}">${i.To[0].Address}</span>` ;
                    }
                },
                {
                    Key: "IletiTip",
                    Title: this.translate('remPreview.messageType'),
                    //SortField: "Name"
                },
                {
                    Key: "Subject",
                    Title: this.translate('draftEyp.subject'),
                    //SortField: "Name"
                },
                {
                    Key: "SentDate",
                    Title: this.translate('draftEyp.date'),
                    SortField: "SentDate",
                    Content(i){
                        return Vue.filter('datetime')(i.SentDate);
                    }
                },
                // {
                //     Key: "IsActive",
                //     Title:"Aktif",
                //     SortField: "IsActive",
                //     Class: "text-center",
                //     Style: "width:1px",
                //     Content(i) {
                //         return Vue.filter('checkicon')(i.IsActive);
                //     }
                // }
            ]
        }
    },
    components: {
        list,
        //ExcelExporter,
        listContainer
    }
}
</script>